import React from 'react';
import './alertmodal.css';

const AlertModal = ({ response, onSecondClick, setShowModal, reset }) => {

    window.onclick = function (event) {
        var modal = document.getElementById("myModal");
        if (event.target == modal) {
            setShowModal(false)
        }
        if (response.ok && event.target == modal) {
            reset()
            setShowModal(false)     
        }
    }

    const onFirstClick = () => {
        setShowModal(false)
        if (response.ok) {
            reset()
        }
    }

    return <div id="myModal" className="modal">
    <div className="modal-content">
        <div style={{ marginBottom: '20px' }}>
            {response.msg}
        </div>

        <div className="alert alert-warning" role="alert">
            <strong>Please note:</strong> Shipment information cannot be modified once the address label has been generated.
        </div>

        <div
            className="col"
            style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}
        >
            <button
                type="button"
                className="btn btn-primary"
                onClick={onFirstClick}
            >
                OK!
            </button>

            {response.ok && (
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onSecondClick}
                >
                    Generate Address Label
                </button>
            )}
        </div>
    </div>
</div>
}

export default AlertModal;